import React from 'react';

export default {
    fields: [
        {
            type: 'file',
            name: 'file',
            props: {
                label: <p><i className="asterisk icon inline"/>CSV File</p>,
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/storeFinderImportConfig.js